import { LoadingButton } from "@mui/lab";
import { Box, Button } from "@mui/material";
import { useState } from "react";

export const withStepperButtons = (Component) => {
    const ComponentWithStepperButtons = (props) => {
        const { first, last, disableNextButton, disableBackButton, ...rest } = props;
        const { loading, handleNext, handleBack } = props;

        const [valid, setValid] = useState(false);

        return <>
            <Component {...rest} onChangeValid={valid => setValid(valid)} />
            <Box sx={{ mb: 2 }}>
                <Box>
                    {!disableNextButton && handleNext && <LoadingButton
                        variant="contained"
                        onClick={handleNext}
                        sx={{ mt: 1, mr: 1 }}
                        disabled={!valid}
                        loading={loading}
                    >
                        {last ? 'Finish' : 'Continue'}
                    </LoadingButton>}
                    {!disableBackButton && <Button
                        onClick={() => handleBack(first)}
                        sx={{ mt: 1, mr: 1 }}
                        disabled={loading}
                    >
                        {first ? 'Cancel' : 'Back'}
                    </Button>}
                </Box>
            </Box>
        </>;
    }

    return ComponentWithStepperButtons;
}